module.exports = __webpack_public_path__ + "static/osaka-5-e9299fcd9b92d96c82a0647dc3da07ea.png";